import { createContext, useContext } from 'react';

/** The agent's name as the owner configured it (Settings, "What do you call your agent?"); "Amy" until one is set. */
export const defaultAgentName = 'Amy';
const AgentName = createContext(defaultAgentName);
export const AgentNameProvider = AgentName.Provider;
export function useAgentName() { return useContext(AgentName) || defaultAgentName; }
/** Server copy names the agent "Amy" (blocker next steps, the policy summary); show it in the configured name. */
export function withAgent(text: string, agent: string) { return agent === defaultAgentName ? text : text.replace(/\bAmy\b/g, agent); }
